import { render, staticRenderFns } from "./topNav.vue?vue&type=template&id=896c0c60&scoped=true"
import script from "./topNav.vue?vue&type=script&lang=js"
export * from "./topNav.vue?vue&type=script&lang=js"
import style0 from "./topNav.vue?vue&type=style&index=0&id=896c0c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896c0c60",
  null
  
)

export default component.exports